import { useState } from 'react';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import ContactAutocomplete from '../../components/contact-autocomplete/contact-autocomplete';
import { formatContactName } from '../../pages/contacts/format-contact-name';

function ModifyInstance({ instance, handleClose, handleConfirm, error }) {
  const [contact, setContact] = useState(null);

  const prepareFormData = () => {
    return {
      ...instance,
      contactId: contact ? contact.id : null,
      contactName: contact ? formatContactName(contact) : null,
    };
  };
  const isFormReady = !!contact;

  return (
    <Dialog
      open={true}
      onClose={handleClose}
      aria-labelledby="Add Channel with secure payment"
    >
      <DialogTitle>Add Channel with secure payment</DialogTitle>
      <DialogContent sx={{ width: 300, maxWidth: '600px' }}>
        {error && (
          <Alert severity="error" sx={{ marginBottom: 3 }}>{error}</Alert>
        )}
        <ContactAutocomplete
          label="Contact"
          value={contact}
          onChange={setContact}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={() => handleConfirm(prepareFormData())} autoFocus disabled={!isFormReady}>Save</Button>
      </DialogActions>
    </Dialog>
  );
}

export default ModifyInstance;
